import { useDreamSearchFilterContext } from "@portal/app/health/_components/components/filter/DreamSearchFilterContext";
import { faEnvelopeOpenDollar } from "@fortawesome/pro-duotone-svg-icons/faEnvelopeOpenDollar";
import { useState } from "react";
import { useDreamSearchContext } from "@portal/app/health/_components/DreamSearchContext";
import { FilterPill } from "./OnlineClassesFilterPill";
import { useMixpanel } from "@portal/app/_components/hooks/useMixpanel";

export const PaymentPlanFilterPill = () => {
  const analytics = useMixpanel();
  const { filterSettings } = useDreamSearchContext();
  const { filters, setFilters } = useDreamSearchFilterContext();
  const [isActive, setIsActive] = useState(
    !!filters["program_payment_options_type_in"]?.includes("SCHOOL_PAYMENT_PLAN")
  );

  return filterSettings?.paymentOptionType.includes("SCHOOL_PAYMENT_PLAN") ? (
    <FilterPill
      onClick={() => {
        setIsActive(!isActive);
        if (!isActive) {
          void analytics.track("Dream Search - Filter", {
            featured: "Payment plan",
            filterGroup: "program_payment_options_type_in",
            filterItem: "SCHOOL_PAYMENT_PLAN",
            filters,
          });
        }
        return setFilters(({ program_payment_options_type_in, ...prevFilters }) => ({
          ...prevFilters,
          program_payment_options_type_in: isActive ? [] : ["SCHOOL_PAYMENT_PLAN"],
        }));
      }}
      isActive={isActive}
      title="Payment plan"
      iconProps={{
        icon: faEnvelopeOpenDollar,
        color: isActive ? "#04299E" : "#04299E70",
      }}
      data-testid="dream-search-filter-payment-plan"
    />
  ) : null;
};
